// extracted by mini-css-extract-plugin
export default {"melodyVideo":"AK-z","isFullWidth":"BK-z","landingPageVideo":"CK-z","play":"DK-z","iframeVideo":"EK-z","playHidden":"FK-z","fullwidth":"GK-z"};